import { render, staticRenderFns } from "./DossierWaterPotability.vue?vue&type=template&id=fd288874&scoped=true&"
import script from "./DossierWaterPotability.vue?vue&type=script&lang=js&"
export * from "./DossierWaterPotability.vue?vue&type=script&lang=js&"
import style0 from "./DossierWaterPotability.vue?vue&type=style&index=0&id=fd288874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd288874",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
